(function ($) {

    'use strict';
    theme.AssetsLoader.onPageLoaded(function () {
        
        initBannerSwiper();
        let timer=null;
        $('body').on("mouseenter",".media-box",function(){
            $(this).find(".second_media_img").css("display","none");
            $(this).find(".second_media_video").css("display","block");
            // 延迟100毫秒，等视频显示出来再播放，不然会有报错
            timer=setTimeout(()=>{
                $(this).find(".second_media_video .second-video-obj").each(function(){
                    this.play();
                });
            },100);
            
        })
        $('body').on("mouseleave",".media-box",function(){
            timer && clearTimeout(timer);
            $(this).find(".second_media_img").css("display","block");
            $(this).find(".second_media_video").css("display","none");
            $(this).find(".second_media_video .second-video-obj").each(function(){
                this.pause();
            });
        })
     
        if(CgGlobalUtils.isMobile()){
            setTimeout(()=>{
                let height = $('.section-feature').find('.square').height()*2+16
                $('.section-feature .l4cl').css("height",height)
                $('body').on('click','.show-more',function(e){
                    let itemVal = $(this).find('button').text() 
                    if(itemVal == 'Show More'){
                        $(this).prev().css("height","auto")
                        $(this).find('button').text('Show Less')
                    }else{
                        $(this).prev().css("height",height)
                        $(this).find('button').text('Show More')
                    }		
                })
            },0)	
            
        }
    
        function initBannerSwiper() {
            var is_autoplay = $('.mySwiper').data('is_autoplay');
            var autoplay_delay = $('.mySwiper').data('autoplay_delay');
            var slide_number=Number($('.mySwiper').data('slide_number') || '0');
            var isAutoplay = Boolean(is_autoplay);
            var autoplayDelay = Number(autoplay_delay);
            var autoplayObj = isAutoplay ? { delay: autoplayDelay * 1000 } : false;
            var swiper = new Swiper(".mySwiper", {
                pagination: {
                    el: ".mySwiper .swiper-pagination",
                    clickable: true
                },
                loop: slide_number > 1 ? true:false,
                navigation: {
                    nextEl: ".mySwiper .swiper-button-next",
                    prevEl: ".mySwiper .swiper-button-prev",
                },
                autoplay: autoplayObj
            });
        }
       
    });
})(jQueryTheme);